import React, {
  createContext,
  PropsWithChildren,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from 'react';
import noop from 'lodash/noop';
import FileViewerDialog from 'pages/Dashboard/components/Dialog/FileViewerDialog';

type DialogProps = {
  title?: string;
  content: ReactNode;
};

type ContextValues = {
  openDialog: (props: DialogProps) => void;
  closeDialog: () => void;
};

export const FileViewerContext = createContext<ContextValues>({
  openDialog: noop,
  closeDialog: noop,
});

const DEFAULT_PROPS = { content: null };

export default function FileViewerProvider({ children }: PropsWithChildren) {
  const [props, setProps] = useState<DialogProps>(DEFAULT_PROPS);
  const [open, setOpen] = useState<boolean>(false);

  const openDialog = (_props: DialogProps) => {
    setProps({
      ...DEFAULT_PROPS,
      ..._props,
    });
    setOpen(true);
  };

  const closeDialog = useCallback(() => setOpen(false), []);

  const values = useMemo(() => ({
    openDialog,
    closeDialog,
  }), [openDialog, closeDialog]);

  return (
    <FileViewerContext.Provider value={values}>
      <FileViewerDialog
        open={open}
        onClose={closeDialog}
        {...props}
      >
        {props.content}
      </FileViewerDialog>
      {children}
    </FileViewerContext.Provider>
  );
}
